import {
  ElementRef,
  Renderer2 as Renderer,
} from '@angular/core';

export interface BlockSizeType {
  /**
   * @abstract number & className corresponding to the max width of the block in pixels & the class name to apply
   */
  [className: string]: number;
}

export interface ICustomBlock {
  el: ElementRef;
  renderer: Renderer;
  width?: number;
  currentWidth?: number;
}

export function CreateCustomBlockSizeType(
  blockSizeType: BlockSizeType
): ClassDecorator {
  return (type: any) => {
    if (type.prototype.checkSize) {
      return;
    }

    type.prototype.checkSize = (_this: ICustomBlock) => {
      _this.width = _this.el.nativeElement.clientWidth;
      _this.currentWidth = _this.currentWidth ?? 0;
      if (_this.width === _this.currentWidth) {
        return;
      }
      _this.currentWidth = _this.width ?? _this.currentWidth;

      const classToApply = Object.keys(blockSizeType)
        .sort((a, b) => blockSizeType[a] - blockSizeType[b])
        .find((className) => (_this.width ?? 0) < blockSizeType[className]);

      const appliedClasses = _this.el.nativeElement.className.split(' ') as string[];
      appliedClasses.forEach((appliedClass) => {
        if (appliedClass in blockSizeType) {
          _this.renderer.removeClass(_this.el.nativeElement, appliedClass);
        }
      });

      if (!classToApply) {
        return;
      }

      _this.renderer.addClass(_this.el.nativeElement, classToApply);
    };
    const ngAfterViewInit = type.prototype.ngAfterViewInit;
    type.prototype.ngAfterViewInit = function (this: ICustomBlock) {
      type.prototype.checkSize(this);

      if (ngAfterViewInit) {
        ngAfterViewInit.call(this);
      }
    };

    const ngDoCheck = type.prototype.ngDoCheck;
    type.prototype.ngDoCheck = function (this: ICustomBlock) {
      type.prototype.checkSize(this);

      if (ngDoCheck) {
        ngDoCheck.call(this);
      }
    };
  };
}
